import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Tab, TabList, Tabs, TabPanel } from "react-tabs";


import httpService from "../../services/httpService";
import { redirect, getToken, getFromStorage, setToken, setToStorage, redirectInternal } from "../../services/authService";

const Pricing = () => {
  const [message, setMessage] = useState("");
  const [success, setSuccess] = useState(false);
  const [sessionId, setSessionId] = useState("");
  const [subscriptionPlan, setSubscriptionPlan] = useState("");
  const [loader, setLoader] = useState(false);
  // const query = new URLSearchParams(window.location.search);

  const location = useLocation();
  const query = new URLSearchParams(location.search);

  useEffect(() => {
    const success = query.get("success");
    const sessionId = query.get("session_id");

    if (success && sessionId) {
      setSuccess(true);
      // ✅ Get plan from localStorage instead of state
      const plan = localStorage.getItem("subscriptionPlan");

      setSubscriptionPlan(plan);

      setSessionId(query.get('session_id'));
      setMessage(
        subscriptionPlan === "member_monthly"
          ? "Your subscription has been successfully created! You now have access to the Member Plan."
          : subscriptionPlan === "extended_monthly"
            ? "Your subscription has been successfully created! You now have access to the Extended Plan."
            : ""
      );
      updateCheckoutSession(plan, sessionId, success);
    } else if (query.get('canceled')) {
      setSuccess(false);
      setMessage(
        "Order canceled — continue to shop around and checkout when you're ready."
      );
    } else {
      setMessage("");
    }
  }, [location.search]); // runs whenever query changes

  const createCheckoutSession = async (lookupKey) => {
    try {
      setLoader(true);
      const response = await httpService.post('news/create-checkout-session', {
        // Your request payload
        lookup_key: lookupKey,
      });

      const plan = response.data?.subscriptionPlan;

      // ✅ Persist plan across redirect
      localStorage.setItem("subscriptionPlan", plan);

      if (response.data?.url) {
        window.location.href = response.data.url;
      };
    } catch (error) {
      setLoader(false);
    }
  };

  const updateCheckoutSession = async (plan, sessionId, status) => {
    try {
      setLoader(true);
      const response = await httpService.patch(`subscription/${sessionId}`, {
        // Your request payload
        subscriptionPlan: plan,
        paymentStatus: status,
      });

      if (response.data.data.paymentStatus) {
        redirectInternal("/subscription/payment?status=success");
      };
    } catch (error) {
      setLoader(false);
    }
  };

  const getSubcription = async () => {
    try {
      setLoader(true);
      const response = await httpService.get("subscription/user-subscriptions");
      const isEmpty = (obj) =>
        !obj || !response.data.data || Object.keys(response.data.data).length === 0;

      if (isEmpty(response)) {
        setSubscriptionPlan("basic");
        setLoader(false);
      } else if (response.status === 200) {
        setSubscriptionPlan(response.data.data.subscriptionPlan);
        setLoader(false);
      };
    } catch (error) {
      console.log("Error happened here:", error);
      setLoader(false);
    }
  };

  useEffect(() => {
    getSubcription();
  }, []);

  const handleUpdateCard = async (e) => {
    try {
      setLoader(true);
      const response = await httpService.patch("subscription/edit/update-card", {});
      if (response.status === 200) {
        if (response.data?.url) {
          window.location.href = response.data.url;
        };
      }
    } catch (error) {
      setLoader(false);
      console.log("Error happened here:", error);
    }
  };

  return (
    <section className="pricing-section">
      <div className="tf-container st3">
        <div className="row">
          <div className="col-lg-12">
            <Tabs className="group-pricing-v1 tf-tab">
              <h5>{subscriptionPlan === "basic" ? "Try UKICNews free for 7 days — immigration updates and sponsorship jobs included." : "Subscribe or Upgrade to avoid interruption to opportunites"}</h5>
              <p>{subscriptionPlan === "basic" ? "You are currently on the Basic plan. Upgrade to access all content." : "You are on a paid plan. Enjoy full access to UKIC News."}</p>
              <br />
              {loader ? (<section className="account-section">
                <div className="tf-container">
                  <div className="row">
                    <div className="wd-form-login">
                      <h4>Loading subscription...</h4>
                    </div>
                  </div>
                </div>
              </section>) : (<>
                <div className="content-tab">
                  <TabPanel className="inner animation-tab">
                    <div className="group-col-3">

                      <div className={`pricing-box cl3 ${subscriptionPlan === "basic" ? "active" : ""}`}>
                        <div className="group-tag">
                          <div className="tag1">Basic</div>
                        </div>
                        <div className="pricing">
                          £0.00<span>/month</span>
                        </div>
                        <ul className="wd-list-icon">
                          <li>
                            <span className="icon">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={20}
                                height={20}
                                viewBox="0 0 20 20"
                                fill="none"
                              >
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10Z"
                                  fill="#012169"
                                />
                                <path
                                  d="M8.39644 13.8429L5.14644 10.3563C4.95119 10.1468 4.95119 9.80718 5.14644 9.59769L5.85353 8.8391C6.04879 8.62961 6.36539 8.62961 6.56064 8.8391L8.75 11.1878L13.4394 6.1571C13.6346 5.94763 13.9512 5.94763 14.1465 6.1571L14.8536 6.91569C15.0488 7.12516 15.0488 7.46479 14.8536 7.67428L9.10355 13.8429C8.90828 14.0524 8.5917 14.0524 8.39644 13.8429Z"
                                  fill="white"
                                />
                              </svg>
                            </span>
                            Limited access to UKIC News content
                          </li>
                          <li>
                            <span className="icon">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={20}
                                height={20}
                                viewBox="0 0 20 20"
                                fill="none"
                              >
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10Z"
                                  fill="#012169"
                                />
                                <path
                                  d="M8.39644 13.8429L5.14644 10.3563C4.95119 10.1468 4.95119 9.80718 5.14644 9.59769L5.85353 8.8391C6.04879 8.62961 6.36539 8.62961 6.56064 8.8391L8.75 11.1878L13.4394 6.1571C13.6346 5.94763 13.9512 5.94763 14.1465 6.1571L14.8536 6.91569C15.0488 7.12516 15.0488 7.46479 14.8536 7.67428L9.10355 13.8429C8.90828 14.0524 8.5917 14.0524 8.39644 13.8429Z"
                                  fill="white"
                                />
                              </svg>
                            </span>
                            Limited access to UK Sponsorship Jobs
                          </li>

                        </ul>
                        {subscriptionPlan === "basic" ? (
                          <h5 to="#" className="text-success text-center">
                            Active
                          </h5>
                        ) : null}
                      </div>

                      <div className={`pricing-box cl3 ${subscriptionPlan === "price_1SiPkxB9juHKlap6XT4JJleX" ? "active" : ""}`}>
                        <div className="group-tag">
                          <div className="tag1">Monthly Plan</div>
                          <div className="tag2"> Popular</div>
                        </div>
                        <div className="pricing">
                          £3.99<span>/month</span>
                        </div>
                        <ul className="wd-list-icon">
                          <li>
                            <span className="icon">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={20}
                                height={20}
                                viewBox="0 0 20 20"
                                fill="none"
                              >
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10Z"
                                  fill="#012169"
                                />
                                <path
                                  d="M8.39644 13.8429L5.14644 10.3563C4.95119 10.1468 4.95119 9.80718 5.14644 9.59769L5.85353 8.8391C6.04879 8.62961 6.36539 8.62961 6.56064 8.8391L8.75 11.1878L13.4394 6.1571C13.6346 5.94763 13.9512 5.94763 14.1465 6.1571L14.8536 6.91569C15.0488 7.12516 15.0488 7.46479 14.8536 7.67428L9.10355 13.8429C8.90828 14.0524 8.5917 14.0524 8.39644 13.8429Z"
                                  fill="white"
                                />
                              </svg>
                            </span>
                            Full access to all UKIC News content
                          </li>
                          <li>
                            <span className="icon">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={20}
                                height={20}
                                viewBox="0 0 20 20"
                                fill="none"
                              >
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10Z"
                                  fill="#012169"
                                />
                                <path
                                  d="M8.39644 13.8429L5.14644 10.3563C4.95119 10.1468 4.95119 9.80718 5.14644 9.59769L5.85353 8.8391C6.04879 8.62961 6.36539 8.62961 6.56064 8.8391L8.75 11.1878L13.4394 6.1571C13.6346 5.94763 13.9512 5.94763 14.1465 6.1571L14.8536 6.91569C15.0488 7.12516 15.0488 7.46479 14.8536 7.67428L9.10355 13.8429C8.90828 14.0524 8.5917 14.0524 8.39644 13.8429Z"
                                  fill="white"
                                />
                              </svg>
                            </span>
                            Sponsorship job opportunities
                          </li>
                          <li>
                            <span className="icon">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={20}
                                height={20}
                                viewBox="0 0 20 20"
                                fill="none"
                              >
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10Z"
                                  fill="#012169"
                                />
                                <path
                                  d="M8.39644 13.8429L5.14644 10.3563C4.95119 10.1468 4.95119 9.80718 5.14644 9.59769L5.85353 8.8391C6.04879 8.62961 6.36539 8.62961 6.56064 8.8391L8.75 11.1878L13.4394 6.1571C13.6346 5.94763 13.9512 5.94763 14.1465 6.1571L14.8536 6.91569C15.0488 7.12516 15.0488 7.46479 14.8536 7.67428L9.10355 13.8429C8.90828 14.0524 8.5917 14.0524 8.39644 13.8429Z"
                                  fill="white"
                                />
                              </svg>
                            </span>
                            Immigration updates & alerts
                          </li>
                          <li>
                            <span className="icon">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={20}
                                height={20}
                                viewBox="0 0 20 20"
                                fill="none"
                              >
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10Z"
                                  fill="#012169"
                                />
                                <path
                                  d="M8.39644 13.8429L5.14644 10.3563C4.95119 10.1468 4.95119 9.80718 5.14644 9.59769L5.85353 8.8391C6.04879 8.62961 6.36539 8.62961 6.56064 8.8391L8.75 11.1878L13.4394 6.1571C13.6346 5.94763 13.9512 5.94763 14.1465 6.1571L14.8536 6.91569C15.0488 7.12516 15.0488 7.46479 14.8536 7.67428L9.10355 13.8429C8.90828 14.0524 8.5917 14.0524 8.39644 13.8429Z"
                                  fill="white"
                                />
                              </svg>
                            </span>
                            Clear explanations of policies
                          </li>
                          <li>
                            <span className="icon">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={20}
                                height={20}
                                viewBox="0 0 20 20"
                                fill="none"
                              >
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10Z"
                                  fill="#012169"
                                />
                                <path
                                  d="M8.39644 13.8429L5.14644 10.3563C4.95119 10.1468 4.95119 9.80718 5.14644 9.59769L5.85353 8.8391C6.04879 8.62961 6.36539 8.62961 6.56064 8.8391L8.75 11.1878L13.4394 6.1571C13.6346 5.94763 13.9512 5.94763 14.1465 6.1571L14.8536 6.91569C15.0488 7.12516 15.0488 7.46479 14.8536 7.67428L9.10355 13.8429C8.90828 14.0524 8.5917 14.0524 8.39644 13.8429Z"
                                  fill="white"
                                />
                              </svg>
                            </span>
                            Cancel anytime
                          </li>
                          <li>
                            <span className="icon">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={20}
                                height={20}
                                viewBox="0 0 20 20"
                                fill="none"
                              >
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10Z"
                                  fill="#012169"
                                />
                                <path
                                  d="M8.39644 13.8429L5.14644 10.3563C4.95119 10.1468 4.95119 9.80718 5.14644 9.59769L5.85353 8.8391C6.04879 8.62961 6.36539 8.62961 6.56064 8.8391L8.75 11.1878L13.4394 6.1571C13.6346 5.94763 13.9512 5.94763 14.1465 6.1571L14.8536 6.91569C15.0488 7.12516 15.0488 7.46479 14.8536 7.67428L9.10355 13.8429C8.90828 14.0524 8.5917 14.0524 8.39644 13.8429Z"
                                  fill="white"
                                />
                              </svg>
                            </span>
                            Flexible access, billed monthly
                          </li>
                        </ul>
                        {subscriptionPlan === "price_1SiPkxB9juHKlap6XT4JJleX" ? (
                          <>
                            <h5 to="#" className="text-success text-center">
                              Active
                            </h5>
                          </>
                        ) : (<Link to="#" onClick={() => createCheckoutSession("price_1SiPkxB9juHKlap6XT4JJleX")} className="btn">
                          Upgrade
                        </Link>)}
                      </div>

                      <div className={`pricing-box  cl3 ${subscriptionPlan === "price_1SvLG0B9juHKlap6E1a5HJPV" ? "active" : ""}`}>
                        <div className="group-tag">
                          <div className="tag1">Quarterly Plan</div>
                          <div className="tag1"> Best value</div>
                        </div>
                        <div className="pricing">
                          £9.97<span>/ 3 month</span>
                        </div>
                        <ul className="wd-list-icon">
                          <li>
                            <span className="icon">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={20}
                                height={20}
                                viewBox="0 0 20 20"
                                fill="none"
                              >
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10Z"
                                  fill="#012169"
                                />
                                <path
                                  d="M8.39644 13.8429L5.14644 10.3563C4.95119 10.1468 4.95119 9.80718 5.14644 9.59769L5.85353 8.8391C6.04879 8.62961 6.36539 8.62961 6.56064 8.8391L8.75 11.1878L13.4394 6.1571C13.6346 5.94763 13.9512 5.94763 14.1465 6.1571L14.8536 6.91569C15.0488 7.12516 15.0488 7.46479 14.8536 7.67428L9.10355 13.8429C8.90828 14.0524 8.5917 14.0524 8.39644 13.8429Z"
                                  fill="white"
                                />
                              </svg>
                            </span>
                            Full access to all UKIC News content
                          </li>
                          <li>
                            <span className="icon">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={20}
                                height={20}
                                viewBox="0 0 20 20"
                                fill="none"
                              >
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10Z"
                                  fill="#012169"
                                />
                                <path
                                  d="M8.39644 13.8429L5.14644 10.3563C4.95119 10.1468 4.95119 9.80718 5.14644 9.59769L5.85353 8.8391C6.04879 8.62961 6.36539 8.62961 6.56064 8.8391L8.75 11.1878L13.4394 6.1571C13.6346 5.94763 13.9512 5.94763 14.1465 6.1571L14.8536 6.91569C15.0488 7.12516 15.0488 7.46479 14.8536 7.67428L9.10355 13.8429C8.90828 14.0524 8.5917 14.0524 8.39644 13.8429Z"
                                  fill="white"
                                />
                              </svg>
                            </span>
                            Sponsorship job opportunities
                          </li>
                          <li>
                            <span className="icon">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={20}
                                height={20}
                                viewBox="0 0 20 20"
                                fill="none"
                              >
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10Z"
                                  fill="#012169"
                                />
                                <path
                                  d="M8.39644 13.8429L5.14644 10.3563C4.95119 10.1468 4.95119 9.80718 5.14644 9.59769L5.85353 8.8391C6.04879 8.62961 6.36539 8.62961 6.56064 8.8391L8.75 11.1878L13.4394 6.1571C13.6346 5.94763 13.9512 5.94763 14.1465 6.1571L14.8536 6.91569C15.0488 7.12516 15.0488 7.46479 14.8536 7.67428L9.10355 13.8429C8.90828 14.0524 8.5917 14.0524 8.39644 13.8429Z"
                                  fill="white"
                                />
                              </svg>
                            </span>
                            Immigration updates & alerts
                          </li>
                          <li>
                            <span className="icon">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={20}
                                height={20}
                                viewBox="0 0 20 20"
                                fill="none"
                              >
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10Z"
                                  fill="#012169"
                                />
                                <path
                                  d="M8.39644 13.8429L5.14644 10.3563C4.95119 10.1468 4.95119 9.80718 5.14644 9.59769L5.85353 8.8391C6.04879 8.62961 6.36539 8.62961 6.56064 8.8391L8.75 11.1878L13.4394 6.1571C13.6346 5.94763 13.9512 5.94763 14.1465 6.1571L14.8536 6.91569C15.0488 7.12516 15.0488 7.46479 14.8536 7.67428L9.10355 13.8429C8.90828 14.0524 8.5917 14.0524 8.39644 13.8429Z"
                                  fill="white"
                                />
                              </svg>
                            </span>
                            Clear explanations of policies
                          </li>

                          <li>
                            <span className="icon">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={20}
                                height={20}
                                viewBox="0 0 20 20"
                                fill="none"
                              >
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10Z"
                                  fill="#012169"
                                />
                                <path
                                  d="M8.39644 13.8429L5.14644 10.3563C4.95119 10.1468 4.95119 9.80718 5.14644 9.59769L5.85353 8.8391C6.04879 8.62961 6.36539 8.62961 6.56064 8.8391L8.75 11.1878L13.4394 6.1571C13.6346 5.94763 13.9512 5.94763 14.1465 6.1571L14.8536 6.91569C15.0488 7.12516 15.0488 7.46479 14.8536 7.67428L9.10355 13.8429C8.90828 14.0524 8.5917 14.0524 8.39644 13.8429Z"
                                  fill="white"
                                />
                              </svg>
                            </span>
                            Lower cost per month & cancel anytime
                          </li>

                          <li>
                            <span className="icon">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={20}
                                height={20}
                                viewBox="0 0 20 20"
                                fill="none"
                              >
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10Z"
                                  fill="#012169"
                                />
                                <path
                                  d="M8.39644 13.8429L5.14644 10.3563C4.95119 10.1468 4.95119 9.80718 5.14644 9.59769L5.85353 8.8391C6.04879 8.62961 6.36539 8.62961 6.56064 8.8391L8.75 11.1878L13.4394 6.1571C13.6346 5.94763 13.9512 5.94763 14.1465 6.1571L14.8536 6.91569C15.0488 7.12516 15.0488 7.46479 14.8536 7.67428L9.10355 13.8429C8.90828 14.0524 8.5917 14.0524 8.39644 13.8429Z"
                                  fill="white"
                                />
                              </svg>
                            </span>
                            Best value, billed every 3 months
                          </li>
                        </ul>
                        {subscriptionPlan === "price_1SvLG0B9juHKlap6E1a5HJPV" ? (
                          <h5 to="#" className="text-success text-center">
                            Active
                          </h5>
                        ) : (<Link to="#" onClick={() => createCheckoutSession("price_1SvLG0B9juHKlap6E1a5HJPV")} className="btn">
                          Upgrade
                        </Link>)}
                      </div>
                    </div>
                  </TabPanel>
                </div>
              </>)}
            </Tabs>
            <Link onClick={handleUpdateCard} className="btn text-primary">
              * View Billing Portal to manage your subscription
            </Link>
            <br />
            <Link onClick={handleUpdateCard} className="btn text-primary">
              * Update Credit/Debit Card details
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Pricing;
